import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { registerSW } from 'virtual:pwa-register';
import { router } from './router';
import './styles.css';

// The service worker that makes the app installable and lets the shell open
// with no connection. Configured in vite.config.ts; a no-op under `vite dev`.
// In autoUpdate mode this reloads the page once a new version has installed.
registerSW({ immediate: true });

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Attendance is edited by one person at a time in a classroom; refetching
      // on every window focus would fight the teacher's in-progress edits.
      refetchOnWindowFocus: false,
      retry: (failureCount, error) =>
        // Never retry an auth or permission failure - it will not succeed.
        typeof error === 'object' &&
        error !== null &&
        'status' in error &&
        typeof (error as { status: unknown }).status === 'number' &&
        [401, 403, 404].includes((error as { status: number }).status)
          ? false
          : failureCount < 2,
    },
  },
});

const container = document.getElementById('root');
if (!container) throw new Error('missing #root');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
